import Slider from './Slider';
import Title from '../common/Title';

export default function SliderWithTitle (props) {
  const passTypeList = ['spot', 'subspot', 'live', 'program', 'event', 'ad'];
  let mainContentsType;

  if (passTypeList.includes(props.type)) {
    mainContentsType = props.type;
  } else if (props.type === 'new_vod') {
    mainContentsType = 'newvod';
  } else if (props.type === 'myvod') {
    mainContentsType = 'program';
  } else if (props.type === 'pnews'){
    mainContentsType = 'soup';
  }else {
    mainContentsType = 'hotclip';
  }

  let sliderType;
  switch (props.type) {
    case 'poster':
    case 'program':
      sliderType = 'poster';
      break;
    case 'event':
      sliderType = 'event';
      break;
    case 'live':
      sliderType = 'thumb'; // 640
      break;
    default:
      sliderType = 'thumb';
  }

  const keyIndex = props.slide_key;

  // 메인 페이지 에서  이벤트 일때 전체 추가  bottom_type(jsonData에서는 === mainContentsType)
  return (
    <div className={props.wrapperClass || 'main_contents_' + mainContentsType}>
      <Slider
        view={props.view}
        slide_key={keyIndex}
        type={sliderType}
        data={props.data}
        relate_id={props.relate_id}
        relate_title={props.relate_title}
        relate_title_view_yn={props.relate_title_view_yn}
        relate_type={props.relate_type}
        bottom_type={props.bottom_type}
        imageQuality={75}
        clickParams={props.clickParams}
      >

        <Title type={props.type} title={props.title} desc={props.desc} link={props.link} mainContentsType={mainContentsType} />
      </Slider>
    </div>

  );
}
